import {
  Directive,
  Input,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[focus]'
})
export class FocusDirective {
  @Input() focus:boolean;
  constructor(private element: ElementRef) {}

  protected ngOnChanges() {
    if (this.focus) {
      this.element.nativeElement.focus();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/search/focus.directive.ts